import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { CampaignConfiguration } from './campaign-configuration';
import { validateStep } from './validate-step';
import { useNavigate, useRouteParams } from '../../../../../infra/routing';
import { goToNextStep } from './go-to-next-step';
import { useSession } from '../../../../../infra/session';
import { goToPreviousStep } from './go-to-previous-step';
import { useApiMutation } from '../../../../../infra/api';
import { endpoints } from '../../../network';
import { useBreakpoints } from '../../../../../infra/dls/hooks/use-get-breakpoints';
import { useSetupDefaultCtaColor, useEditableField, useCampaignDetails } from '../../hooks';
export var CampaignConfigurationContainer = function () {
    var store = useStore();
    var navigate = useNavigate();
    var session = useSession().data;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var campaignId = useRouteParams().campaignId;
    var campaignTypeField = useEditableField('type').field;
    var campaign = useCampaignDetails(campaignId).campaign;
    useSetupDefaultCtaColor();
    var isPromoCampaign = (campaignTypeField === null || campaignTypeField === void 0 ? void 0 : campaignTypeField.value) === 'promotion';
    var createCampaignMutation = useApiMutation({ endpoint: endpoints.createCampaignMutation });
    var updateCampaignMutation = useApiMutation({ endpoint: endpoints.updateCampaignMutation });
    var handleNextStep = function () {
        var isCurrentStepValid = validateStep({ store: store });
        if (isCurrentStepValid) {
            goToNextStep({ store: store, navigate: navigate, session: session, campaignId: campaignId, createCampaignMutation: createCampaignMutation, updateCampaignMutation: updateCampaignMutation, campaign: campaign });
        }
    };
    var handlePreviousStep = function () {
        goToPreviousStep({ store: store, navigate: navigate, session: session, campaignId: campaignId });
    };
    return (_jsx(CampaignConfiguration, { onNextStep: handleNextStep, onPreviousStep: handlePreviousStep, displayStepTitle: !isMobileOrSmaller, displayPromoInput: isPromoCampaign }));
};
